import {
  useGetCurrentUserQuery,
  useGetOrganizationQuery,
} from '@carboncopyco/data';
import { type Role, ShareSecurityLevel } from '@carboncopyco/types';

type Roles = Exclude<Role, 'visitor'>;
type SharingRoles = Exclude<Roles, 'owner'>;

export const useAllowedShareSecurityLevels = (organizationId: string) => {
  const { data: userData } = useGetCurrentUserQuery();
  const { data: organization } = useGetOrganizationQuery({
    id: organizationId,
  });

  const {
    sharingPolicy = {},
    demoSharingApproval = {},
    tourSharingPolicy,
  } = organization ?? {};

  const rolesForSharePolicy: Record<Roles, SharingRoles> = {
    owner: 'admin',
    admin: 'admin',
    presenter: 'presenter',
    editor: 'editor',
  };
  const userRole: SharingRoles =
    rolesForSharePolicy[userData?.user?.roles?.[organizationId]];

  const allowedDemoSecurityLevels = Object.keys(sharingPolicy)
    .filter((key) => sharingPolicy[key].includes(userRole))
    .map((item) => ShareSecurityLevel[item]) as ShareSecurityLevel[];

  const allowAnyoneSecurityLevelForTour =
    tourSharingPolicy?.anyone.includes(userRole);
  const allowedTourSecurityLevels: ShareSecurityLevel[] = [
    ShareSecurityLevel.internal,
    ShareSecurityLevel.restricted,
    ShareSecurityLevel.emailDomain,
    ...(allowAnyoneSecurityLevelForTour ? [ShareSecurityLevel.anyone] : []),
  ];

  const shareLevelsRequiringApproval = Object.keys(demoSharingApproval)
    .filter((key) => demoSharingApproval[key])
    .map((item) => ShareSecurityLevel[item]) as ShareSecurityLevel[];

  return {
    allowedDemoSecurityLevels,
    allowedTourSecurityLevels,
    shareLevelsRequiringApproval,
    userRole,
  };
};
